export default __webpack_public_path__ + "images/st-72697a87cfc011963be4361604931288.svg";